module.exports = __webpack_public_path__ + "static/assets/3b36ccde4f4ca63d8abd0d8d5cd1e608.svg";